var map = {
	"./Bixi.webp": 5618,
	"./Elephant.webp": 89154,
	"./Fire Horse.webp": 42843,
	"./Hedgehog.webp": 14427,
	"./Horse_2.webp": 66228,
	"./Huye.webp": 53500,
	"./Jiaotu.webp": 26139,
	"./Kamaja.webp": 34834,
	"./Kirin.webp": 52815,
	"./Phoenix.webp": 31275,
	"./Shishi.webp": 2671,
	"./Spring cattle.webp": 88213,
	"./Suanni.webp": 59238,
	"./Sword Lion.webp": 76303,
	"./bat.webp": 60122,
	"./dragon.webp": 80399,
	"./suanni_2.webp": 67693,
	"./vote-logo.webp": 67789
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86444;